// extracted by mini-css-extract-plugin
export default {"input":"input_input__S92Zb","label":"input_label__3zLVR","active":"input_active__Vxu0U","bold":"input_bold__aNHqx"};